export const configs = {
  PROTOCOL: "https://",
  DOMAIN: "cibogm-platform.igf.edu.pl",
  AUTH_PORT: "",
  DATA_PORT: "",
};
